import { render, staticRenderFns } from "./ExpansionPanelNotificationItem.vue?vue&type=template&id=6490627c"
import script from "./ExpansionPanelNotificationItem.vue?vue&type=script&lang=js"
export * from "./ExpansionPanelNotificationItem.vue?vue&type=script&lang=js"
import style0 from "./ExpansionPanelNotificationItem.vue?vue&type=style&index=0&id=6490627c&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbsdevops/devops/jenkins-slave/workspace/bizbize-frontend-dev/xpermeet-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6490627c')) {
      api.createRecord('6490627c', component.options)
    } else {
      api.reload('6490627c', component.options)
    }
    module.hot.accept("./ExpansionPanelNotificationItem.vue?vue&type=template&id=6490627c", function () {
      api.rerender('6490627c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Notifications/RoomNotifications/ExpansionPanelNotificationItem.vue"
export default component.exports